export default "__VITE_ASSET__c66534d2__"